import React from "react";
import LogoSection from "./LogoSection";
import MenuSection from "./MenuSection";
import "../Styles/IcaseHeaderStyles.css";

const IcastHeader = () => {
  return (
     <>
        <LogoSection />
        <MenuSection />
     </>
 
  );
};

export default IcastHeader;
